<template>
  <div class="affiliate-activity">
    <div class="head">
      <div class="control">
        <div class="section">
          <div class="date-range-picker">
            <UiDatePicker
              v-model="dateRange"
              :preset-dates-factory="getQuickDates"
              :default-value="2"
              custom-input
              auto-apply
            />
          </div>
          <div class="filter">
            <UiRadioGroup
              v-model="initiator_type"
              :options="[
                {
                  label: $t('affiliates.affiliatesActivity.panel'),
                  value: 'affiliate',
                },
                {
                  label: $t('affiliates.affiliatesActivity.admin'),
                  value: 'admin',
                },
                {
                  label: $t('affiliates.affiliatesActivity.overall'),
                  value: 'all',
                }
              ]"
              @change="getLog"
            />
          </div>
        </div>
        <div class="section">
          <div class="pagination">
            <UiPagination
              :page="page"
              :page-size="limit"
              :count="count"
              show-size-select
              @page-change="pageChange"
            />
          </div>
        </div>
      </div>
    </div>
    <UiTable
      v-loading="isDataLoading"
      :fields="fields"
      :data="data"
      :rows-count="limit"
      lazy-loading
      is-static
      i18n-path="affiliates.list"
      element-loading-custom-class="data-loader-spinner"
      disable-sort
    />
  </div>
</template>

<script>
import { format, subDays, startOfDay, endOfDay } from 'date-fns';
import { pageSizeMixin, resolvePageSize } from '@/service/pageSize';
import updateUrl from '../../../service/updateUrl';

const sizes = {
  1080: 20,
  1440: 30,
};

const viewName = 'affiliate/activity/limit'; // для локалсторедж
const pageSize = resolvePageSize(viewName, {
  _default: 15,
  sizes,
});

export default {
  name: 'AffiliateActivity',
  mixins: [pageSizeMixin],
  data() {
    return {
      viewName,
      id: '',
      info: {},
      fields: [
        {
          name: 'action_timestamp',
          align: 'left',
          width: '140',
          format: 'date',
          formatOptions: {
            in: '',
            out: 'dd MMM yyyy HH:mm:ss',
          },
        },
        {
          name: 'action_name',
          align: 'left',
          width: '400',
          overflow: true,
        },
        {
          name: 'ip_address',
          align: 'left',
          format: 'ip-flag',
          class: 'ip-flex',
        },
        {
          name: 'initiator',
          align: 'left',
          renderValue: this.initiatorRender,
        },
        {
          name: 'os',
          align: 'left',
          renderValue: this.osRender,
        },
        {
          name: 'device',
          align: 'left',
          renderValue: this.deviceRender,
        },
      ],
      data: [],
      count: 0,
      page: 1,
      limit: pageSize,
      isDataLoading: false,
      dateRange: [],
      initiator_type: 'admin',
    };
  },
  computed: {

    quickDates() {
      const today = new Date();
      return [
        {
          label: this.$t('ui.shortcuts.relative_time_ranges'),
          value: {
            short_title: 'group',
            type: 'group-title',
          },
          slot: 'preset-date-range-button',
        },
        {
          label: this.$t('affiliates.affiliatesActivity.week'),
          value: {
            range: [subDays(today, 6), today],
            type: 'picker',
          },
          slot: 'preset-date-range-button',
        },
        {
          label: this.$t('affiliates.affiliatesActivity.week_2'),
          value: {
            type: 'picker',
            range: [subDays(today, 13), today],
          },
          slot: 'preset-date-range-button',
        },
        {
          label: this.$t('affiliates.affiliatesActivity.month'),
          value: {
            type: 'picker',
            range: [subDays(today, 29), today],
          },
          slot: 'preset-date-range-button',
        },
      ];
    },
    dataQuery() {
      return {
        affiliate_id: this.id,
        initiator_type: this.initiator_type,
        limit: this.limit,
        offset: (this.limit * this.page) - this.limit,
        from: this.dateRange?.[0] ? format(startOfDay(this.dateRange[0]), 'yyyy-MM-dd HH:mm:ss') : '',
        to: this.dateRange?.[1] ? format(endOfDay(this.dateRange[1]), 'yyyy-MM-dd HH:mm:ss') : '',
      };
    },
  },
  watch: {
    dateRange(nv) {
      if (!nv) {
        this.dateRange = this.getQuickDates()[1].value.range;
      }
      this.getLog();
    },
  },
  created() {
    /*
    * Считываем hash
    * */
    const _paramsHash = updateUrl.getParseParams(this.$route.hash);

    if (!this.$_.isEmpty(_paramsHash)) {
      this.dateRange[0] = this.$_.get(_paramsHash, ['dateStart']);
      this.dateRange[1] = this.$_.get(_paramsHash, ['dateEnd']);
      this.initiator_type = this.$_.get(_paramsHash, ['initiator_type']) || this.initiator_type;

      this.limit = Number(this.$_.get(_paramsHash, ['limit'])) || pageSize;
      this.page = Number(this.$_.get(_paramsHash, ['page'])) || 1;
    } else {
      this.dateRange = this.getQuickDates()[2].value.range;
      this.limit = +this.$ls.get('affiliate/activity/limit') || pageSize;
    }


    this.id = this.$route.params.id;
    if (!this.id) {
      this.$router.push('/affiliates/list');
    }
  },
  mounted() {
    this.$api
      .getAffiliateInfo(this.id)
      .then((response) => {
        this.info = this.$_.cloneDeepWith(response.data.payload);
      });

    this.getLog();
  },
  methods: {
    getQuickDates() {
      const today = new Date();
      return [
        {
          label: this.$t('ui.shortcuts.relative_time_ranges'),
          value: {
            short_title: 'group',
            type: 'group-title',
          },
          slot: 'preset-date-range-button',
        },
        {
          label: this.$t('affiliates.affiliatesActivity.week'),
          value: {
            range: [subDays(today, 6), today],
            type: 'picker',
          },
          slot: 'preset-date-range-button',
        },
        {
          label: this.$t('affiliates.affiliatesActivity.week_2'),
          value: {
            type: 'picker',
            range: [subDays(today, 13), today],
          },
          slot: 'preset-date-range-button',
        },
        {
          label: this.$t('affiliates.affiliatesActivity.month'),
          value: {
            type: 'picker',
            range: [subDays(today, 29), today],
          },
          slot: 'preset-date-range-button',
        },
      ];
    },
    initiatorRender(field, row) {
      return `${row.initiator_name} (${row.initiator_type})`;
    },
    deviceRender(field, row) {
      if (row.device_vendor || row.device_mode) {
        return `${row.device_vendor}/${row.device_model}`;
      }
      return 'unknown';
    },
    osRender(field, row) {
      if (field || row.browser) {
        return `${field}/${row.browser}`;
      }
      return 'unknown';
    },

    pageChange(page, size) {
      this.page = page;
      this.limit = size;
      this.getLog();
    },
    async getLog() {
      this.isDataLoading = true;

      /*
      * Update URL
      * */
      this._completedFilterUrl();
      try {
        const {
          data: {
            misc,
            payload,
          },
        } = await this.$api.getAffiliateActivity(this.dataQuery);
        this.count = misc.count;
        this.data = payload;
      } finally {
        this.isDataLoading = false;
      }
    },
    /*
    * Создаем filter URL
    * */
    _completedFilterUrl() {
      const _dataFilters = {
        dateStart: this.dateRange?.[0] ? format(this.dateRange[0], 'yyyy-MM-dd') : '',
        dateEnd: this.dateRange?.[1] ? format(this.dateRange[1], 'yyyy-MM-dd') : '',
        limit: this.limit,
        page: this.page,
        initiator_type: this.initiator_type,
      };
      updateUrl.updateGetParams(_dataFilters);
    },
  },
};
</script>
